<template>
  <div class="login-container">
    <el-form ref="loginForm" class="login-form" autocomplete="on"  :rules="rules" label-position="left">

      <div class="title-container">
        <h3 class="title">天一阅卷</h3>
      </div>

        <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="用户名"
          name="username"
          type="text"
          tabindex="1"
          @input="handlerChange"
         
        />
      </el-form-item>

    
        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="密码"
            name="password"
            tabindex="2"
            @keyup.enter.native="loginAsAdmin"

          />
    
        </el-form-item>
        <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="loginAsAdmin">登录</el-button>
        <br>
        <el-button  v-show="isphone"  type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="getphonepw">短信获取密码</el-button>

        
    </el-form>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {

  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      isphone: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      loading: false,
    }
  },
   methods: {
          login: function (parmas) {
          this.loading = true
          window.console.log('click login button')

          this.$store.dispatch('login', parmas).then(response => {
            this.loading = false

            if (response.code) {

              this.$router.push('/')
            } else {

              const instance = this.$notify({
                type: 'error',
                title: response.msg,
                message: '账号或密码错误!',
              })

              
            }
          })
        },

         strlen:function(str){
          var len = 0;
          for (var i=0; i<str.length; i++) { 
          var c = str.charCodeAt(i); 
          //单字节加1 
          if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) { 
            len++; 
          } 
          else { 
            len+=2; 
          } 
          } 
          return len;
      },
        
         loginAsAdmin: function () {

           let un=this.loginForm.username.trim();
           let pw=this.loginForm.password.trim();

           if (this.strlen(un)<3||this.strlen(pw)<3) 
           {

             	this.$message({
              showClose: true,
              message: '请输入正确的用户名,密码!',
              type: 'error'
              });


             return;
           }




            const parmas = {
              userName: this.loginForm.username,
              userPw: this.loginForm.password,
            }
            this.login(parmas)
          },

           
          validatePhTelNumber: function (str) {
            const reg = /^((\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14})|([1][3,4,5,6,7,8,9][0-9]{9})$/
            return reg.test(str)
          },

           handlerChange:function(){
            window.console.log('input change!!')

            let usrname=this.loginForm.username;
            if (this.validatePhTelNumber(usrname)==true&&this.strlen(usrname)==11)
            {
              window.console.log('手机号')
              this.isphone=true
            }
            else
            {
              this.isphone=false
            }

          },

        
          getphonepw: function () {
            let usrname=this.loginForm.username;

                axios.post('/yj?op=getphonepw',qs.stringify({"phone":usrname,"ip":'127.0.0.1'})).then((res)=>{
         
                  console.log(res)
                  console.log(res.data)

                  if (res.data.msg=='success')
                  {

                      this.$alert(res.data.detail, res.data.msg, {
                      confirmButtonText: '确定',
                      type: 'info',
                      callback: action => {
                       
                      }
                    });
                  }
                  else
                  {

                    this.$alert(res.data.detail, '错误', {
                      confirmButtonText: '确定',
                      type: 'warning',
                      callback: action => {
                        
                      }
                    });

                  }

                 
                        

                  
              }).catch((res)=>{
                  console.log(response)
              })      

         },

   }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg:#283443;
$light_gray:#fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg:#2d3a4b;
$dark_gray:#889aa4;
$light_gray:#eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
